import React from "react";

const joinClassNames = (...classes) => classes.filter(Boolean).join(" ");

export default function IconButton({
  children,
  containerClassName = "",
  className = "",
  type = "button",
  "data-testid": dataTestId,
  ...buttonProps
}) {
  return (
    <div className={joinClassNames("flex items-center justify-center", containerClassName)}>
      <button
        type={type}
        className={joinClassNames(
          "inline-flex items-center justify-center border-0 bg-transparent",
          className
        )}
        data-testid={dataTestId}
        {...buttonProps}
      >
        {children}
      </button>
    </div>
  );
}
